import { render, staticRenderFns } from "./WaitingPayment.vue?vue&type=template&id=c4c2ee6e&scoped=true&"
import script from "./WaitingPayment.vue?vue&type=script&lang=js&"
export * from "./WaitingPayment.vue?vue&type=script&lang=js&"
import style0 from "./WaitingPayment.vue?vue&type=style&index=0&id=c4c2ee6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c2ee6e",
  null
  
)

component.options.__file = "WaitingPayment.vue"
export default component.exports